import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const formStyles: BoxStyleProps = {
    padding: "space40",
    paddingTop: "space80",
    overflow: "auto"
};

export const titleStyles: TextStyleProps = {
    fontSize: "fontSize70",
    marginBottom: "space60"
};

export const introStyles: TextStyleProps = {
    marginBottom: "space70"
};

export const fieldStyles: BoxStyleProps = {
    marginBottom: "space70"
};

export const conversationStyles: BoxStyleProps = {
    borderWidth: "borderWidth10",
    borderStyle: 'solid',
    borderColor: 'colorBorderWeaker',
    padding: "space50",
    borderRadius: 'borderRadius20'
}

export const writeHereStyles: BoxStyleProps = {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "space40",
    borderWidth: "borderWidth10",
    borderStyle: 'solid',
    borderColor: 'colorBorderWeaker',
    borderRadius: 'borderRadius20'
}